/**
 * Add the feature names you want to fetch from the backend here
 */
export enum TenantFeatureConfigurationFeatureName {
  Translations = 'Translations',
  AiSuggestions = 'AI Suggestions',
  WhatsappMessaging = 'Whatsapp Messaging',
  SailAi = 'Sail Quest AI',
  UiConfiguration = 'UI Configuration',
  BulkAiAssistantCall = 'Bulk AI Assistant Call',
  BulkAiVoiceCall = 'Bulk AI Voice Call',
  UserPhoneRequired = 'User Phone Required',
  LeadBulkUpdate = 'Lead Bulk Update',
  BulkLeadActivityCreate = 'Bulk Lead Activity Create',
  AddToList = 'Add To List',
  BulkActions = 'Bulk Actions',
  AutomationTimeBuffer = 'Automation Time Buffer',
}

export enum TenantFeatureConfigurationDataType {
  Number = 'number',
  Integer = 'integer',
  String = 'string',
  Boolean = 'boolean',
  Json = 'json',
  Yaml = 'yaml',
}

export interface TenantFeatureConfigurationType {
  id: string;
  featureName: TenantFeatureConfigurationFeatureName;
  configKey: string;
  configValue: number | string | boolean | Record<string, unknown>;
  dataType: TenantFeatureConfigurationDataType;
  createdAt: string;
  updatedAt: string;
}
